import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ffe3324"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "form-list-content"
};
const _hoisted_2 = {
  class: "form-list-content"
};
const _hoisted_3 = {
  class: "form-list-content"
};
import { awaitWrap, OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { getEntityBuFen } from '@/api/payManage/accountManage';
import { addPaidApp, queryPaidAppInfo } from '@/api/paidApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'PaidAddModal',
  props: {
    modalVisible: {
      type: Boolean
    }
  },
  emits: ['update:modalVisible', 'refresh', 'clearEditItem'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const chnlList = [{
      label: '华为',
      value: 'huawei'
    }];
    const visible = ref(false);
    const accountForm = ref();
    const formValue = ref({
      dbtId: undefined,
      appName: undefined,
      mchId: undefined,
      mchName: undefined,
      studio: undefined,
      pkg: undefined,
      accountId: undefined,
      accountName: undefined
    });
    const dbtIdParams = ref('');
    const rules = ref({
      dbtId: [{
        required: true,
        message: '请输入dbtId',
        trigger: 'blur'
      }],
      mchId: [{
        required: true,
        message: '请选择主体/账号',
        trigger: 'change'
      }],
      appName: [{
        required: true,
        message: '请输入dbtId,点击搜索后自动生成',
        trigger: 'change'
      }],
      studio: [{
        required: true,
        message: '请输入dbtId,点击搜索后自动生成',
        trigger: 'change'
      }],
      appId: [{
        required: true,
        message: '请输入appid',
        trigger: 'blur'
      }],
      chnl: [{
        required: true,
        message: '请选择渠道',
        trigger: 'change'
      }]
    });
    const accountList = ref();
    const onSearch = async () => {
      if (!formValue.value.dbtId) {
        return message.error('dbtId不能为空');
      }
      if (formValue.value.dbtId === dbtIdParams.value) {
        return message.error('dbtId与上次相同-无法获取数据');
      }
      let params = {
        dbtId: formValue.value.dbtId
      };
      const [err, data] = await awaitWrap(queryPaidAppInfo(params));
      if (data && data.code === OK) {
        let res = data.data;
        dbtIdParams.value = params.dbtId;
        formValue.value = {
          accountId: res.accountId,
          accountName: res.accountName,
          appId: res.appId,
          appName: res.appName,
          chnl: res.chnl,
          chnlName: res.chnlName,
          dbtId: res.dbtId,
          // mchId: res.mchId,
          mchName: res.mchName,
          pkg: undefined,
          studio: res.studio
        };
      }
      if (err) {}
    };
    const closeModal = () => {
      var _accountForm$value;
      (_accountForm$value = accountForm.value) === null || _accountForm$value === void 0 || _accountForm$value.clearValidate();
      dbtIdParams.value = '';
      formValue.value = {
        dbtId: undefined,
        appName: undefined,
        mchId: undefined,
        mchName: undefined,
        studio: undefined,
        pkg: undefined,
        accountId: undefined,
        accountName: undefined
      };
      emit('clearEditItem', {});
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      var _accountForm$value2;
      (_accountForm$value2 = accountForm.value) === null || _accountForm$value2 === void 0 || _accountForm$value2.validate().then(async () => {
        let params = {
          accountId: formValue.value.accountId,
          appName: formValue.value.appName,
          chnl: formValue.value.chnl,
          config: {
            appId: formValue.value.appId
          },
          dbtId: formValue.value.dbtId,
          mchId: formValue.value.mchId,
          studio: formValue.value.studio
        };
        const [err, data] = await awaitWrap(addPaidApp(params));
        if (data && data.code === OK) {
          message.success('新增成功');
          emit('refresh');
          closeModal();
          reportEvent({
            eventName: 'element_use',
            properties: {
              'ui_name': '付费产品管理',
              'element_name': '新增'
            }
          });
        }
        if (err) message.error('新增失败');
      }).catch(error => {});
    };
    const getAccountList = async () => {
      const {
        code,
        data
      } = await getEntityBuFen().catch(e => {});
      if (code === OK) {
        accountList.value = data.map(item => {
          return {
            label: item.typeName,
            value: item.id
          };
        });
      }
    };
    watch(() => props.modalVisible, n => {
      visible.value = n;
      if (visible.value) getAccountList();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[6] || (_cache[6] = $event => visible.value = $event),
        title: "新建产品信息",
        width: "650px",
        centered: "",
        "ok-text": "提交",
        onOk: handleOk,
        onCancel: closeModal,
        maskClosable: false,
        class: "paid-add-modal"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "accountForm",
          model: formValue.value,
          ref_key: "accountForm",
          ref: accountForm,
          rules: rules.value
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form_item, {
            label: "dbtID：",
            name: "dbtId"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_search, {
              value: formValue.value.dbtId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.dbtId = $event),
              placeholder: "请输入dbtId搜索",
              onSearch: onSearch
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "主体/账号：",
            name: "mchId"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: formValue.value.mchId,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formValue.value.mchId = $event),
              placeholder: "主体/账号",
              options: accountList.value
            }, null, 8, ["value", "options"])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form_item, {
            label: "产品名：",
            name: "appName"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formValue.value.appName,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formValue.value.appName = $event),
              placeholder: "产品名",
              disabled: ""
            }, {
              suffix: _withCtx(() => [_createVNode(SvgIcon, {
                "icon-class": "jiantouxia",
                "class-name": "add-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "APPID：",
            name: "appId"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formValue.value.appId,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formValue.value.appId = $event),
              placeholder: "APPID",
              disabled: ""
            }, null, 8, ["value"])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_form_item, {
            label: "工作室：",
            name: "studio"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formValue.value.studio,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => formValue.value.studio = $event),
              placeholder: "工作室",
              disabled: ""
            }, {
              suffix: _withCtx(() => [_createVNode(SvgIcon, {
                "icon-class": "jiantouxia",
                "class-name": "add-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "渠道：",
            name: "chnl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: formValue.value.chnl,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => formValue.value.chnl = $event),
              placeholder: "渠道",
              options: chnlList,
              disabled: ""
            }, null, 8, ["value"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});